import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type JivoWidgetResponse as SchemaJivoWidgetResponse } from '../schemas/JivoWidgetResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetJivoWidgetContentType = '' as const;
export type GetJivoWidgetRequest = void;
export type GetJivoWidgetResponses = LinkCommonErrorResponses & {
    /**
     * @description Jivo widget retrieved successfully
     */
    '200': {
        'application/json': SchemaJivoWidgetResponse;
    };
};
export type GetJivoWidgetResponseSuccess = GetJivoWidgetResponses['200']['application/json'];
export type GetJivoWidgetSearchParams = undefined;
export type GetJivoWidgetPathParameters = undefined;
export const GetJivoWidgetUrl = '/integrations/jivo/widget' as const;
export const GetJivoWidgetMethod = 'GET' as const;
export const getGetJivoWidgetUrl = (_params?: GetJivoWidgetPathParameters) => GetJivoWidgetUrl;
